import React, { Component } from 'react'
import Styled, { withTheme } from 'styled-components'

import Loader from 'components/Loader'

const Positioner = Styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 3rem;
`

class PageLoader extends Component {
  render() {
    return (
      <Positioner>
        <Loader variant={this.props.variant} />
      </Positioner>
    )
  }
}

export default withTheme(PageLoader)



// WEBPACK FOOTER //
// ./src/components/PageLoader/index.js